import type { RouteLocationNamedRaw } from 'vue-router'
import type { Team, Player, PlayerRoster, Image } from '~/types'

export const usePlayerRoster = (playerRosterRef: MaybeRefOrGetter<Maybe<PlayerRoster.Model | undefined>>) => {
  const playerRoster = ref<Maybe<PlayerRoster.Model>>()

  const playerRosterPhoto = computed<Maybe<Image>>(() => playerRoster.value?.photo || null)
  const player = computed<Maybe<Player.Model>>(() => playerRoster.value?.player || null)
  const team = computed<Maybe<Team.Model>>(() => playerRoster.value?.roster?.team || null)

  const { slug: playerSlug } = usePlayer(player)

  const { slug: teamSlug } = useTeam(team)

  const permalink = computed<Maybe<RouteLocationNamedRaw>>(() => {
    if (!playerSlug.value || !teamSlug.value) {
      return null
    }

    return {
      name: 'teams-slug-player',
      params: {
        slug: teamSlug.value,
        player: playerSlug.value,
      },
    }
  })

  watchEffect(() => {
    playerRoster.value = toValue(playerRosterRef)
  })

  return {
    permalink,
    team,
    player,
    playerRosterPhoto,
    playerRoster,
  }
}
